// extracted by mini-css-extract-plugin
export default {"section":"Section_section__0XkUm","products":"Section_products__DZYVU Section_section__0XkUm"};